<template>
    <div class="col-xs-12 col-md-3">
        <div
            class="card dashboard-card sm-radius text-center dashbaord-stastics"
        >
            <h2>{{ title }}</h2>
            <p>{{ value }}</p>
            <i
                v-if="icon"
                v-b-tooltip.hover
                class="icon-error_outline"
                title="
                    Average time from when customer details are submitted till when they are approved / rejected.
                "
            ></i>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        path: {
            type: String,
            required: true,
        },
        query: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        status: {
            type: String,
        },

        icon: {
            type: Boolean,
            default: false,
        },
        reset: {
            type: Number,
        },
    },
    data() {
        return {
            value: 0,
        }
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId']),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        reset(value) {
            if (value) {
                this.getStats()
            }
        },
        dataSegmentId(value) {
            if (value) {
                this.noRecordFound = false
                this.showSpinner = true
                this.getStats()
            }
        },
    }, // End of Component > methods
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getStats()
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > created
    |--------------------------------------------------------------------------
    */
    created() {
        this.resourceApi = new resource(this.path)
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getStats() {
            try {
                this.query.dataSegmentId = this.dataSegmentId
                    ? this.dataSegmentId
                    : localStorage.getItem('activeDataSegmentId')
                let { data } = await this.resourceApi.list(this.query)
                if (data && data.data) {
                    if (data.data.length) {
                        if (data.data[0].avgOnboardingTime) {
                            this.value = data.data[0].avgOnboardingTime
                        } else {
                            this.value = data.data[0].count
                        }
                    } else {
                        this.value = 0
                    }
                }
                // False the page loader after the list has been loaded
                this.$store.commit('setLoading', false)
            } catch (error) {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', error)
            }
        }, // getStats() methods end
    }, // End of Component > created
}
</script>
